import type { LanguageCode } from '@/constants/languages';
import { resolveIntlLocale } from '@/utils/locale';

export function formatNumber(value: number, languageCode?: LanguageCode, options?: Intl.NumberFormatOptions): string {
  const locale = resolveIntlLocale(languageCode);

  return new Intl.NumberFormat(locale, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
    ...options,
  }).format(value);
}

function getSeparators(locale: string) {
  const parts = new Intl.NumberFormat(locale).formatToParts(12345.6);
  return {
    group: parts.find(p => p.type === 'group')?.value ?? ',',
    decimal: parts.find(p => p.type === 'decimal')?.value ?? '.',
  };
}

export function parseNumber(raw: string, languageCode?: LanguageCode): number | null {
  const s = raw.trim();
  if (!s) return null;
  const locale = resolveIntlLocale(languageCode);
  const { group, decimal } = getSeparators(locale);

  let normalized = s.replace(/\s+/g, '');

  normalized = normalized.replaceAll(group, '');

  if (decimal !== '.') {
    normalized = normalized.replaceAll(decimal, '.');
  }

  if (normalized.includes(',') && !normalized.includes('.')) {
    normalized = normalized.replaceAll(',', '.');
  } else {
    normalized = normalized.replaceAll(',', '');
  }

  const n = Number(normalized);
  return Number.isFinite(n) ? n : null;
}
